import React, { FC, useMemo } from "react";
import { Response, SuggestionTypes } from "stentor-models";
// import { SearchResponseBubble } from "../SearchResponseBubble";
import { SearchResponseDisplay } from "../SearchResponseDisplay";
import { SearchResponseOutputSpeech } from "../SearchResponseOutputSpeech";
import { SearchResponsePart } from "../SearchResponsePart";
import { SuggestedActions } from "../SuggestedActions";
import "./SearchResponse.scss";
import { useMiddleware } from "../../middlewares/use-middleware";

export interface SearchResponseProps {
    readonly response: Response;
    readonly responseId: string;
    readonly className?: string;
    onActionClick(action: SuggestionTypes): void;
    onActionResponse(data: unknown, action: string): void;
    onAudioChange(isOn: boolean): void;
}

export const SearchResponse: FC<SearchResponseProps> = props => {
    const { response, responseId, className, onActionClick, onActionResponse, onAudioChange } = props;
    const { outputSpeech } = response;
    const displays = response.displays;
    const actions = typeof outputSpeech === "object" ? outputSpeech.suggestions : undefined;

    const middlewareCtx = useMemo(() => ({ onActionResponse }), [onActionResponse]);
    const middleware = useMiddleware();

    return (
        <div className={`xapp-search-response ${className || ""}`}>
            {!!outputSpeech && (
                <SearchResponseOutputSpeech outputSpeech={outputSpeech} onAudioChange={onAudioChange} responseId={responseId} />
            )}

            {!!actions?.length && actions?.length > 0 && (
                <SuggestedActions actions={actions} onActionClick={onActionClick} />
            )}

            {!!displays?.length && displays?.length > 0 &&
                displays.map((display, index) => {
                    // When nobody wants the message this will be null (see UnknownMessage)
                    return middleware({ msg: display, ctx: middlewareCtx }) ||

                        (<SearchResponsePart key={index}>
                            <SearchResponseDisplay display={display} />
                        </SearchResponsePart>);
                })}
        </div>
    );
}
